/* eslint-disable */

/* 一些表单验证*/

//判断是否为数字（整数或浮点数：1，1.2，1.，-1，-1.2）
export function isNumber (value) {
  value += '';
  return /^-?[0-9]+\.?[0-9]*$/.test(value);
}

//判断是否为整数  (有弊端，数字1.0也是true)
export function isInt (value) {
  value += '';
  return /^-?[0-9]+$/.test(value);
}

//判断是否为正整数
export function isPositiveInt (value, min, max) {
  value += '';
  return /^[0-9]+$/.test(value);
}

//小写字母
export function isLowerCase (value) {
  value += '';
  return /^[a-z]+$/.test(value);
}

//大写字母
export function isUpperCase (value) {
  value += '';
  return /^[A-Z]+$/.test(value);
}

//大小写字母
export function isAlphabets (value) {
  value += '';
  return /^[A-Za-z]+$/.test(value);
}

//匹配数字及大小写字母
export function isNumberOrChars (value) {
  value += '';
  return /^[A-Za-z0-9]+$/.test(value);
}

//判断是否为手机号
export function isPhoneNumber (value) {
  value += '';
  return /^1\d{10}$/.test(value);
}

//判断是否为座机
export function isTelNumber (value) {
  value += '';
  return /^\d{3}-\d{8}$/.test(value) || /^\d{4}-\d{7}$/.test(value);
}

//判断是否为座机、手机号
export function isPhoneOrTelNum (value) {
  value += '';
  return /^\d{3}-\d{8}$/.test(value) || /^\d{4}-\d{7}$/.test(value) || /^1\d{10}$/.test(value);
}

//判断是包含中文
export function hasChiness (value) {
  value += '';
  return /[\u4e00-\u9fa5]+/.test(value);
}

//判断是包含空格
export function hasSpace (value) {
  value += '';
  return /\s/.test(value);
}

//合法url
export function isURL (value) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return urlregex.test(value);
}

//验证 Email
export function isEmail (value) {
  const re = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  return re.test(value);
}
